import { Capacitor } from '@capacitor/core';
import {
  PushNotifications,
  type Token,
  type ActionPerformed,
} from '@capacitor/push-notifications';

export const PENDING_CONV_KEY = 'wasla_pending_conv';

async function saveFcmToken(token: string): Promise<void> {
  try {
    const jwt = localStorage.getItem('waslacrm_token');
    await fetch('/api/fcm-tokens', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(jwt ? { Authorization: `Bearer ${jwt}` } : {}),
      },
      body: JSON.stringify({ token, platform: 'android' }),
    });
  } catch (error) {
    console.error('[PushNotifications] Failed to save FCM token:', error);
  }
}

// Register tap listener at app start (before login/render)
export function registerNotificationTapListener(): void {
  if (!Capacitor.isNativePlatform()) return;

  PushNotifications.addListener(
    'pushNotificationActionPerformed',
    (_action: ActionPerformed) => {
      // FCM on Android doesn't reliably pass custom data when app is killed.
      // Set localStorage for cold-start and dispatch event for background-resume.
      localStorage.setItem('wasla_notif_tapped', '1');
      window.dispatchEvent(new CustomEvent('wasla-notif-tapped'));
    },
  );
}

export async function initPushNotifications(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  // Create high-importance channel for heads-up notifications
  await PushNotifications.createChannel({
    id: 'wasla_messages',
    name: 'رسائل جديدة',
    description: 'إشعارات الرسائل الواردة',
    importance: 5, // IMPORTANCE_HIGH
    visibility: 1,
    sound: 'default',
    vibration: true,
    lights: true,
  });

  const permResult = await PushNotifications.requestPermissions();
  if (permResult.receive !== 'granted') {
    console.warn('[PushNotifications] Permission not granted');
    return;
  }

  await PushNotifications.register();

  PushNotifications.addListener('registration', (token: Token) => {
    saveFcmToken(token.value);
  });

  PushNotifications.addListener('registrationError', (error) => {
    console.error('[PushNotifications] Registration error:', error);
  });
}
